export const environment = {
  production: false,
  API_ENDPOINT : "http://localhost:3000/", // Mock
  HSM_API_ENDPOINT : "http://localhost:3000/hsmapi/",
  MFS_API_ENDPOINT : "http://localhost:3000/mfs/",
  MFS_USER_GROUP_API_ENDPOINT : 'http://localhost:3000/mfs-user-group-management/',
  WALLET_MANAGEMENT_ENDPOINT : "http://localhost:3000/",
  LIMIT_MANAGEMENT_ENDPOINT : "http://localhost:3000/",
  ENDPOINT: 'http://localhost:3000/',
  USER_MFS: 'http://localhost:3000/',
  COMMON_UTILS: 'http://localhost:3000/',
  LOGIN_MFS: 'http://localhost:3000/',
  MFS_SERVICE_MANAGEMENT_API_ENDPOINT: 'http://localhost:3000/',
  MFS_REPORTS_ENDPOINT : "http://localhost:3000/mfs-reporting-service/",
  SOCKET_URL:"https://prod.spicelabs.in/paypro",
  BILLER_ENDPOINT:"http://devpp.spicelabs.in/paypro/biller/",
  IMAGE_STORAGE_ENDPOINT: "https://static.spicelabs.in/UploadedDataDev/",
  CRM_ENDPOINT: "http://localhost:3000/",
  SHOW_MODULE: {
    "dashboard":false,
    "walletManagement": true,
    "serviceManagement": true,
    "serviceGroupManagement": true,
    "ruleManagement": true,
    "userGroupManagement": true,
    "hierarchyManagement": true,
    "limitsAndCapping": true,
    "promocodeManagement": true,
    "loginManagement": true,
    "operations": true,
    'billerManagement': true,
    'brmsTestPad': true,
    'cashinManagement': true,
    'notificationManagement': true,
    'reports': false,
    'kycRequests': true,
    'mpc': false,
    'fundTransfer': true,
  },
  OPEN_MODULE:['main/wallet-management/manage-wallet']
};



// WEBPACK FOOTER //
// /Users/ldt/Desktop/ARES-admin-frontend/src/environments/environment.mock.ts